import compose from "ramda/es/compose";
import flatten from "ramda/es/flatten";
import values from "ramda/es/values";
import dotPath from "ramda-extension/es/dotPath";
import composeAction from './composeAction';
export const flattenObject = compose(flatten, values);
export const getFieldValue = (field, formData, temporaryData)=>dotPath(field.deepPath, field.temp ? temporaryData : formData);
export { composeAction };
